import { render, staticRenderFns } from "./RssFeedSection.vue?vue&type=template&id=7348c4d0&scoped=true"
import script from "./RssFeedSection.vue?vue&type=script&lang=js"
export * from "./RssFeedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7348c4d0",
  null
  
)

export default component.exports